/**
 * A GitHub username as the server checks it (#1578): letters and digits, with
 * single hyphens or underscores inside, up to 39 characters. A leading @ is fine.
 * Planning write-back assigns issues through it, so "a,b" must not be saved.
 */
const GITHUB_LOGIN = /^@?(?!.*--)[A-Za-z0-9](?:[A-Za-z0-9_-]{0,37}[A-Za-z0-9])?$/

/** The hint for a handle the server would refuse; null when it is fine or empty. */
export function githubHandleProblem(draft: string): string | null {
  const v = draft.trim()
  return v && !GITHUB_LOGIN.test(v) ? 'Letters, digits and hyphens only' : null
}
